import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsFillPrinterFill, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";

import {useNavigate, useParams} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {HiOutlineLocationMarker, HiOutlineQrcode} from "react-icons/hi";
import {BsCalendar4Week} from "react-icons/bs";
import {TbCoin, TbStatusChange} from "react-icons/tb";
import { CiPercent, CiViewList} from "react-icons/ci";
import {GiTwoCoins} from "react-icons/gi";
import {BiSolidPhoneCall, BiSolidSelectMultiple} from "react-icons/bi";
import {LiaUserEditSolid} from "react-icons/lia";
import {RiMoneyDollarCircleLine, RiUserLine} from "react-icons/ri";
import {GoShieldCheck, GoStar} from "react-icons/go";
import RatingModal from "./RatingModal";
import StarRating from "./StarRating";
import ScoreStars from "./ScoreStars";
import {HiOutlineCheckBadge} from "react-icons/hi2";



const currencyFormat = Intl.NumberFormat('en-US');

function OrderDetails() {
    const navigate = useNavigate();
    const {id} = useParams();

    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [order, setOrder] = React.useState([]);
    const [status, setStatus] = React.useState(4);
    const [showRatingModal, setShowRatingModal] = React.useState(false);

    let totalPrice = 0;
    let totalDiscount = 0;
    let totalTax = 0;
    React.useEffect(() => {
        API.getUserInfo()
            .then((response) => {

                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        const params = {
            'processFor' : 'Suppliers',
            'vendor_id' : window.localStorage.getItem("vendor"),
            orderBy: 'id',
            orderType: 'desc',
        }

        API.getOrder(params , id)
            .then((response) => {
                setOrder(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {

                if(error.response) {
                    toast.error(error.response.data.message);
                    setTimeout (() => {
                        window.history.back()
                    },400)
                }
                else {
                    toast.error(error.message);
                    setTimeout (() => {
                        window.history.back()
                    },400)
                }
            });


    }, [id, status]);


    const onButtonClick =  (statusId) => {
        setIsLoaded(false);
        const request = {
            order: id,
            status : statusId,
            'processFor' : 'Suppliers',
            'vendor_id' : window.localStorage.getItem("vendor")
        }
        API.updateStatus( request )
            .then((response) => {
                toast.success(response.message);
                window.location.reload()
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            });
    }
    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }



    const onEditClick = () => {
        let cart = [];

        for (let c = 0; c < order.details.length; c++) {

            cart.push({'item': parseInt(order.details[c].product.id), 'count': parseInt(order.details[c].count)})
        }
        window.localStorage.setItem("cart", JSON.stringify(cart));

        const orderId = id;
        const marketId = window.localStorage.getItem("vendor");
        navigate(`/vendor/${marketId}/${orderId}`)
    }


    React.useEffect(() => {

        // شرط نمایش خودکار مودال
        if (order && order.last_status && order.last_status.id > 2 && order.vendor_score < 1) {
            setShowRatingModal(true);
        }
    }, [order]); // این افکت با تغییر اطلاعات سفارش، مجدد اجرا می‌شود

    const handleCloseModal = () => {
        setShowRatingModal(false);
    };

    const handleSubmitRating = (score) => {

        setIsLoaded(false);
        const request = {
            order: id,
            score,
            'processFor' : 'Suppliers',
            'vendor_id' : window.localStorage.getItem("vendor")
        }
        API.storeScore( request )
            .then((response) => {
                toast.success(response.message);
                window.location.reload()
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            });


        handleCloseModal();
    };


    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <RatingModal
                show={showRatingModal}
                handleClose={handleCloseModal}
                handleSubmit={handleSubmitRating}
            />

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>

                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 no-print">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                                 {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )


                                        </div>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/1`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                                    سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                             
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/2`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/3`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/products`)}
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/manage`)}
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}

                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
     <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5">

                        <div className="row main-part mx-2 mt-2">
                            <div className="col-12 page-title text-center pb-3 mb-0 border-bottom fw-bold text-muted no-print">
                                جزییات سفارش

                                {
                                    order.vendor_score > 0 &&
                                    <>

                                        <div className='d-flex justify-content-center mt-3'>

                                            <StarRating score={order.vendor_score}/>

                                        </div>
                                        <div className='text-small-3 opacity-50 '>
                                            امتیاز داده شده به این سفارش
                                        </div>
                                    </>

                                }
                            </div>

                            <div className="col-12 ">
                                {
                                isLoaded &&
                                    <section className="container-fluid  mt-3 pb-5 rtl px-0    ">
                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-5 text-small-2">
                                                کد رهگیری:
                                            </div>
                                            <div className="col-6 text-start fw-bold text-small-2">
                                                {order.tracking_code}
                                            </div>
                                        </div>
                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <TbStatusChange/>
                                            </div>
                                            <div className="col-5 text-small-2">
                                                وضعیت سفارش
                                            </div>
                                            <div className="col-6 text-start fw-bold text-small-2"
                                                 style={{color: order.last_status.color}}>
                                                {order.last_status.title}
                                            </div>


                                        </div>

                                        <div className="row mx-2 mb-3  border-bottom pb-2">
                                            <div className="col-1">
                                                <BsCalendar4Week/>
                                            </div>
                                            <div className="col-4 text-small-2">
                                                تاریخ ثبت
                                            </div>
                                            <div className="col-7 text-start fw-bold text-small-2">
                                                {order.date}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3  border-bottom pb-2">
                                            <div className="col-1">
                                                <RiUserLine/>
                                            </div>
                                            <div className="col-4 text-small-2">
                                                نام مشتری
                                            </div>
                                            <div className="col-7 text-start fw-bold text-small-2">
                                                {order.user.name} &nbsp; {order.user.surname}

                                            </div>
                                            {order.user?.credit_status?.length > 0 &&
                                                <>
                                                    <div className="col-1 mt-3">
                                                        <GoShieldCheck/>
                                                    </div>
                                                    <div className="col-4 text-small-2  mt-3">
                                                        وضعیت در گروه استعلام:
                                                        <span
                                                            className=' fw-bold me-1 mt-2 text-muted text-start'>
                                                {order.user?.credit_status[0].name}
                                            </span>
                                                    </div>
                                                    <div className="col-7 text-start  mt-3">


                                                        <img src={order.user?.credit_status[0].image}
                                                             alt={order.user?.credit_status[0].name} width={40}
                                                             height={40} style={{objectFit: 'contain'}}/>


                                                    </div>
                                                </>

                                            }

                                            <div className="col-1 mt-3">
                                                <GoStar/>
                                            </div>
                                            <div className="col-4 text-small-2  mt-3">
                                                امتیاز:
                                                {" "}
                                                <b>{order.user?.orders_score?.average_score}</b>
                                                {" "}
                                                <div className='text-small-3 mt-2 text-center'>
                                                    (از
                                                    {" "}
                                                    {order.user?.orders_score?.total_ratings}
                                                    {" "}
                                                    سفارش)
                                                </div>

                                            </div>

                                            <div className="col-7 text-start  mt-3">
                                                <div className='d-flex justify-content-end'>
                                                    <StarRating score={order.user?.orders_score?.average_score}/>

                                                </div>

                                            </div>
                                            <div className="col-12 border-bottom pb-3">
                                                <ScoreStars score_counts={user?.orders_score?.score_counts}/>
                                            </div>



                                            <div className="col-1 mt-3">
                                                <RiMoneyDollarCircleLine/>
                                            </div>
                                            <div className="col-4 text-small-2  mt-3">
                                                میانگین سفارش:
                                                {" "}

                                                {" "}
                                                <div className='text-small-3 mt-2 text-center'>
                                                    (از
                                                    {" "}
                                                    {user?.orders_average_payment?.count}
                                                    {" "}
                                                    سفارش تحویل شده

                                                    )
                                                </div>

                                            </div>

                                            <div className="col-7 text-start  mt-3">

                                                <div className='d-flex justify-content-end '>

                                                    <strong>{currencyFormat.format(user?.orders_average_payment?.average)}</strong>

                                                    {" "}

                                                    ریال


                                                </div>

                                            </div>


                                        </div>
                                        <div className="row mx-2 mb-3  border-bottom pb-2">
                                            <div className="col-1">
                                            <BiSolidPhoneCall/>
                                            </div>
                                            <div className="col-4 text-small-2">
                                            شماره تماس
                                            </div>
                                            <div className="col-7 text-start fw-bold text-small-2">
                                                <a href={`tel:${order.user.username}`}> {order.user.username}</a>
                                            </div>
                                        </div>


                                        <div className="row mx-2 mb-3 pb-2 custom-card">
                                            <div className="col-1">
                                                <HiOutlineLocationMarker/>
                                            </div>
                                            <div className="col-md-7 col-11 text-small-2 pt-1">
                                                <b>{order.address.title}</b> :&nbsp;
                                                {order.address.address}
                                            </div>
                                            <div className="col-md-4 text-start fw-bold text-small-2 pt-1 no-print">
                                                <a href={`geo:${order.address.lat},${order.address.long}`}
                                                   rel="noreferrer" target='_blank'>مشاهده روی نقشه</a>
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 pb-2 custom-card">
                                            <div className="col-1 mb-3">
                                                <CiViewList/>
                                            </div>
                                            <div className="col-11 text-small-2 fw-bold pt-1 mb-3">
                                                فاکتور
                                                &nbsp;

                                                {
                                                    order.cash_discount_percent > 0 ?
                                                        <span
                                                            className='badge badge-pill badge-primary bg-success mx-2 text-small-3 '>
                                                                    نقدی
                                                                </span> :
                                                        <span
                                                            className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    چکی
                                                                </span>

                                                }
                                            </div>

                                            <div className="col-1 text-small-1 text-center border-bottom py-2">
                                                #
                                            </div>
                                            <div className="col-6 text-small-1 text-center border-bottom py-2">
                                                عنوان
                                            </div>
                                            <div className="col-3 text-small-1 text-center border-bottom py-2">
                                                فی
                                            </div>
                                            <div className="col-2 text-small-1 text-center border-bottom py-2">
                                                تعداد
                                            </div>

                                            {

                                                order.details.map((detail, index) => {

                                                    totalPrice += parseInt(detail.price * detail.count);
                                                    if (detail.tax_percent) {
                                                        let taxAmount = detail.tax_percent * detail.price / 100;
                                                        totalTax += parseInt(taxAmount * detail.count);
                                                    }

                                                    if (detail.discount_percent) {
                                                        let discountAmount = detail.discount_percent * detail.price / 100;
                                                        totalDiscount += parseInt(discountAmount * detail.count);
                                                    }


                                                    return (
                                                        <React.Fragment key={index}>
                                                            <div
                                                                className="col-1 text-small-1 text-center border-bottom py-2">
                                                                {index + 1}
                                                            </div>
                                                            <div
                                                                className="col-6 text-small-2 text-center border-bottom py-2 fw-bold">
                                                                {detail.product.name}
                                                            </div>
                                                            <div
                                                                className="col-3 text-small-1 text-center border-bottom py-2">
                                                                {currencyFormat.format(detail.price)}
                                                            </div>
                                                            <div
                                                                className="col-2 text-small-1 text-center border-bottom py-2">
                                                                {detail.count}
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                })


                                            }
                                            <div className="col-2 mt-3">
                                                &nbsp;
                                            </div>
                                            <div className="col-5 mt-3 text-small-3">
                                                <TbCoin className='ms-2'/>
                                                مبلغ فاکتور
                                            </div>
                                            <div className="col-5 fw-bold mt-3 text-secondary text-small-1  text-start">
                                                {currencyFormat.format(totalPrice)}
                                                &nbsp;
                                                <span className='text-small-3 fw-normal '>ریال</span>
                                            </div>
                                            <div className="col-2 mt-3">
                                                &nbsp;
                                            </div>
                                            <div className="col-5 mt-3 text-small-2 pb-2">
                                                <CiPercent className='ms-2'/>
                                                تخفیف
                                            </div>
                                            <div className="col-5 fw-bold mt-3 text-success  pb-2 text-start">
                                                {currencyFormat.format(totalDiscount)}
                                                &nbsp;
                                                <span className='text-small-3 fw-normal '>ریال</span>
                                            </div>
                                            <div className="col-2 mt-3">
                                                &nbsp;
                                            </div>
                                            <div className="col-5 mt-3 text-small-2 pb-2">
                                                <CiPercent className='ms-2'/>
                                                تخفیف حجمی
                                            </div>
                                            <div className="col-5 fw-bold mt-3 text-success  pb-2 text-start">
                                                {currencyFormat.format(order.amount_discount)}
                                                &nbsp;
                                                <span className='text-small-3 fw-normal '>ریال</span>
                                            </div>
                                            <div className="col-2 mt-3">
                                                &nbsp;
                                            </div>
                                            <div className="col-5 mt-3 text-small-2 border-bottom pb-2">
                                                <CiPercent className='ms-2'/>
                                                تخفیف خرید نقدی
                                            </div>
                                            <div
                                                className="col-5 fw-bold mt-3 text-success  border-bottom pb-2 text-start">
                                                {currencyFormat.format(order.pay_amount * (order.cash_discount_percent / 100))}
                                                &nbsp;
                                                ریال
                                            </div>
                                            <div className="col-2 mt-3">
                                                &nbsp;
                                            </div>
                                            <div className="col-5 mt-3 text-small-2 border-bottom pb-2">
                                                <CiPercent className='ms-2'/>
                                                مالیات
                                            </div>
                                            <div
                                                className="col-5 fw-bold mt-3 text-danger  border-bottom pb-2 text-start">
                                                {currencyFormat.format(order.tax_amount)}
                                                &nbsp;
                                                <span className='text-small-3 fw-normal '>ریال</span>
                                            </div>
                                            {
                                                order.festival_prize > 0 && (
                                                    <>
                                            <div className="col-2 mt-3">
                                                &nbsp;
                                            </div>
                                            <div className="col-5 mt-3 text-small-2 border-bottom pb-2 text-warning">
                                                <HiOutlineCheckBadge className='ms-2 '/>
                                                کسر بابت جشنواره
                                            </div>
                                            <div
                                                className="col-5 fw-bold mt-3 text-warning  border-bottom pb-2 text-start">
                                                {currencyFormat.format(order.festival_prize)}
                                                &nbsp;
                                                <span className='text-small-3 fw-normal '>ریال</span>
                                            </div>
                                                    </>
                                                ) }

                                            <div className="col-2 mt-3">
                                                &nbsp;
                                            </div>
                                            <div className="col-5 mt-3 text-small-2">
                                                <GiTwoCoins className='ms-2'/>
                                                قابل پرداخت:
                                            </div>
                                            <div className="col-5 fw-bold mt-3  text-start">
                                                {currencyFormat.format(order.pay_amount * (1 - (order.cash_discount_percent / 100)))}
                                                &nbsp;
                                                <span className='text-small-3 fw-normal '>ریال</span>
                                            </div>
                                        </div>

                                        {
                                            order.last_status.id === 1 &&

                                            <div className='row no-print'>
                                                <div className="col-md-8"></div>
                                                <div className="col-12 col-md-4 mt-3 text-center">
                                                    <button className="btn btn-success text-small-2 w-100"
                                                            onClick={() => {
                                                                onButtonClick(2)
                                                            }}
                                                    >
                                                        تایید سفارش
                                                    </button>
                                                </div>

                                            </div>

                                        }

                                        {
                                            order.last_status.id === 2 ?

                                                <div className='row no-print'>
                                                    <div className="col-md-4 mt-3 text-center">
                                                        &nbsp;
                                                    </div>
                                                    <div className="col-12 col-md-8 mt-3 text-center">
                                                        <button className="btn btn-success text-small-2 w-100"
                                                                onClick={() => {
                                                                    onButtonClick(3)
                                                                }}
                                                        >
                                                            تحویل سفارش
                                                        </button>
                                                    </div>

                                                </div> : ''

                                        }
                                        {
                                            order.last_status.id <3 &&
                                        <div className='row no-print mt-4'>
                                            <div className=' col-md-4'>

                                            </div>
                                            <div className="col-12 col-md-4 mt-3 text-center">
                                                <button className="btn btn-danger text-small-2 w-100"
                                                        onClick={() => {
                                                            onButtonClick(5)
                                                        }}
                                                >
                                                    کنسل کردن سفارش
                                                </button>
                                            </div>
                                            <div className="col-12 col-md-4 mt-3 text-center">
                                                <button className="btn btn-primary text-small-2 w-100"
                                                        onClick={onEditClick}
                                                >
                                                    ویرایش سفارش
                                                </button>
                                            </div>
                                        </div>
                                        }
                                        <div className="row no-print m-3 pt-5">
                                            <div className="col-12 text-start "
                                                 onClick={() => {
                                                     window.print()
                                                 }}
                                            >
                                                <button className='btn  text-small-1 text-secondary opacity-50'>
                                                    <BsFillPrinterFill/>
                                                    &nbsp;
                                                    پرینت
                                                </button>
                                            </div>
                                        </div>
                                    </section>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default OrderDetails;